import { WithEnterpriseId, WithOwnerId } from '@mews-commander/types';
import { UnicodeEntity } from '@mews/enums';
import { Body } from '@optimus-web/core';
import { useDashboardCorrections } from '../hooks';
import { CorrectionBillCorrectedBillLink } from '../../../../../billDetail/components/CorrectionBillDetailContent/CorrectionBillCorrectedBillLink';

interface CorrectionsCorrectedBillLink extends WithOwnerId, WithEnterpriseId {
    correctedBillId: string;
}

export const CorrectionsCorrectedBillLink = ({
    correctedBillId,
    ownerId,
    enterpriseId,
}: CorrectionsCorrectedBillLink) => {
    const { data } = useDashboardCorrections({ ownerId, enterpriseId });
    const { correctedBills } = data || {};

    const correctedBill = correctedBills?.find((c) => c.id === correctedBillId);

    if (!correctedBill) return <Body>{UnicodeEntity.Dash}</Body>;

    return <CorrectionBillCorrectedBillLink bill={correctedBill} />;
};
